export enum ESortType {
    ASC = 'ASC',
    DESC = 'DESC',
}